/* PureDerm PDP - pd-pdp.js (no dependencies) */
(function () {
  'use strict';
  var d = document;
  function qs(s, r) { return (r || d).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function txt(el, s) { var n = qs(s, el); return n ? n.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function num(t) {
    if (!t) return NaN;
    var m = String(t).replace(/\s/g, '').replace(/[^\d.,]/g, '');
    if (m.indexOf(',') > -1 && m.indexOf('.') > -1) { m = m.replace(/,/g, ''); } else { m = m.replace(',', '.'); }
    return parseFloat(m);
  }
  function money(n) {
    if (isNaN(n)) return '';
    var r = Math.round(n * 100) / 100;
    var s = (r % 1 === 0) ? String(r) : r.toFixed(2);
    return s.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr';
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- Before / after ---------- */
  function initBA(root) {
    qsa('[data-pd-ba]', root).forEach(function (el) {
      if (el.__pd) return; el.__pd = 1;
      var r = qs('input[type=range]', el);
      if (!r) return;
      var u = function () { el.style.setProperty('--pos', r.value + '%'); };
      r.addEventListener('input', u); u();
    });
  }

  /* ---------- Swipe rows: dots + prev/next arrows ---------- */
  var ARROW_L = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var ARROW_R = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
  function initDots(root) {
    qsa('[data-pd-dots]', root).forEach(function (sc) {
      if (sc.__pd) return; sc.__pd = 1;
      var items = sc.children; if (items.length < 2) return;
      var nav = d.createElement('div'); nav.className = 'pd-dots';
      var prev = d.createElement('button'); prev.type = 'button'; prev.className = 'pd-nav pd-nav--prev'; prev.setAttribute('aria-label', 'Föregående'); prev.innerHTML = ARROW_L;
      var next = d.createElement('button'); next.type = 'button'; next.className = 'pd-nav pd-nav--next'; next.setAttribute('aria-label', 'Nästa'); next.innerHTML = ARROW_R;
      var dw = d.createElement('div'); dw.className = 'pd-dots__dots'; dw.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < items.length; i++) dw.appendChild(d.createElement('span'));
      nav.appendChild(prev); nav.appendChild(dw); nav.appendChild(next);
      sc.parentNode.insertBefore(nav, sc.nextSibling);
      var step = function () { var w = items[0].getBoundingClientRect().width || sc.clientWidth; var gap = parseFloat(getComputedStyle(sc).columnGap) || 12; return w + gap; };
      prev.addEventListener('click', function () { sc.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { sc.scrollBy({ left: step(), behavior: 'smooth' }); });
      var raf = 0;
      var u = function () {
        raf = 0;
        var max = sc.scrollWidth - sc.clientWidth;
        nav.hidden = max <= 4;
        var idx = sc.scrollLeft >= max - 4 ? items.length - 1 : Math.round(sc.scrollLeft / step());
        qsa('span', dw).forEach(function (s, j) { s.classList.toggle('is-active', j === idx); });
        prev.disabled = sc.scrollLeft <= 4; next.disabled = sc.scrollLeft >= max - 4;
      };
      var req = function () { if (!raf) raf = requestAnimationFrame(u); };
      sc.addEventListener('scroll', req, { passive: true });
      window.addEventListener('resize', req);
      setTimeout(u, 60); u();
    });
  }

  /* ---------- Kaching bundle helpers (read-only bridge) ---------- */
  function kBars() { return qsa('product-info .kaching-bundles__bar'); }
  function kSettings() {
    var s = qs('script.kaching-bundles-deal-block-settings');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }
  function barData() {
    var st = kSettings();
    return kBars().map(function (b, i) {
      var title = txt(b, '.kaching-bundles__bar-title');
      var q = st && st.dealBars && st.dealBars[i] && st.dealBars[i].quantity;
      if (!q) { var mm = title.match(/\d+/); q = mm ? parseInt(mm[0], 10) : 1; }
      return {
        el: b, i: i, qty: q, title: title,
        sub: txt(b, '.kaching-bundles__bar-subtitle'),
        label: txt(b, '.kaching-bundles__bar-label'),
        badge: txt(b, '.kaching-bundles__bar-most-popular__content'),
        price: num(txt(b, '.kaching-bundles__bar-price')),
        compare: num(txt(b, '.kaching-bundles__bar-full-price')),
        selected: b.classList.contains('kaching-bundles__bar--selected')
      };
    });
  }
  function selectBar(i) {
    var b = kBars()[i]; if (!b) return false;
    var input = qs('input[type=radio]', b);
    if (input && input.checked) return true;
    var l = qs('label', b) || b; l.click();
    return true;
  }
  function mainForm() {
    return qs('product-info form[action*="/cart/add"]') || qs('form[action*="/cart/add"][id^="product-form-template"]');
  }
  function addToCart() {
    var f = mainForm();
    if (!f) { var t = qs('product-info'); if (t) t.scrollIntoView({ behavior: 'smooth' }); return; }
    var sb = qs('button[type=submit][name=add]', f) || qs('button[type=submit]', f) || qs('button[form="' + f.id + '"][type=submit]');
    if (sb && !sb.disabled) { sb.click(); } else if (f.requestSubmit) { f.requestSubmit(); }
  }

  function unitPrices() {
    var hero = qs('.pd-hero[data-unit-prices]'); if (!hero) return;
    barData().forEach(function (b) {
      if (b.qty < 2 || isNaN(b.price)) return;
      var host = qs('.kaching-bundles__bar-pricing', b.el); if (!host) return;
      var label = money(b.price / b.qty) + '/st';
      var ex = qs('.pd-unit', host);
      if (ex) { if (ex.textContent !== label) ex.textContent = label; return; }
      var s = d.createElement('div'); s.className = 'pd-unit'; s.textContent = label; host.appendChild(s);
    });
  }

  function syncOffers() {
    var bars = barData();
    qsa('[data-pd-offers]').forEach(function (box) {
      if (!bars.length) return;
      var btns = qsa('.pd-offer', box);
      if (btns.length !== bars.length) {
        var html = '';
        bars.forEach(function (b) {
          var unit = (b.qty > 1 && !isNaN(b.price)) ? ' · ' + money(b.price / b.qty) + '/st' : '';
          html += '<button type="button" class="pd-offer" data-i="' + b.i + '" aria-pressed="false">' +
            '<span class="pd-offer__radio" aria-hidden="true"></span>' +
            '<span class="pd-offer__main"><span class="pd-offer__title">' + esc(b.title) + (b.badge ? ' <em class="pd-offer__badge">' + esc(b.badge) + '</em>' : '') + '</span>' +
            '<span class="pd-offer__sub">' + esc(b.sub) + unit + '</span></span>' +
            '<span class="pd-offer__price"><strong>' + money(b.price) + '</strong>' + (b.compare > b.price ? '<s>' + money(b.compare) + '</s>' : '') + '</span></button>';
        });
        box.innerHTML = html; box.hidden = false;
        var fb = qs('[data-pd-offers-fallback]', box.parentNode); if (fb) fb.hidden = true;
        btns = qsa('.pd-offer', box);
      }
      btns.forEach(function (btn, j) {
        var on = !!(bars[j] && bars[j].selected);
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
  }

  function syncSticky() {
    var meta = qs('[data-pd-sticky-meta]'); if (!meta) return;
    var sel = barData().filter(function (b) { return b.selected; })[0];
    if (sel && !isNaN(sel.price)) {
      var t = sel.title + ' · ' + money(sel.price);
      if (meta.textContent !== t) meta.textContent = t;
    }
  }

  var tmr = 0;
  function syncAll() { clearTimeout(tmr); tmr = setTimeout(function () { unitPrices(); syncOffers(); syncSticky(); }, 40); }

  function watchKaching() {
    var pi = qs('product-info'); if (!pi || !window.MutationObserver) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t.nodeType === 1 && t.classList && t.classList.contains('pd-unit')) continue;
        syncAll(); return;
      }
    }).observe(pi, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'checked'] });
    syncAll();
  }

  /* ---------- Final CTA ---------- */
  d.addEventListener('click', function (e) {
    var off = e.target.closest && e.target.closest('.pd-offer');
    if (off) { selectBar(parseInt(off.getAttribute('data-i'), 10)); syncAll(); return; }
    var atc = e.target.closest && e.target.closest('[data-pd-atc]');
    if (atc) { e.preventDefault(); addToCart(); }
  });

  /* ---------- Sticky add to cart ---------- */
  function initSticky() {
    var bar = qs('[data-pd-sticky]'); if (!bar || bar.__pd) return; bar.__pd = 1;
    var target = qs('product-info .product-form__submit') || qs('product-info form[action*="/cart/add"]');
    if (!target) return;
    var finals = qsa('[data-pd-final]');
    var shown = null, raf = 0;
    var upd = function () {
      raf = 0;
      var past = target.getBoundingClientRect().bottom < 0;
      var vh = window.innerHeight || d.documentElement.clientHeight;
      var reachedFinal = finals.some(function (f) { return f.getBoundingClientRect().top < vh * 0.9; });
      var show = past && !reachedFinal;
      if (show === shown) return; shown = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) { bar.removeAttribute('inert'); } else { bar.setAttribute('inert', ''); }
      d.documentElement.classList.toggle('pd-sticky-on', show);
    };
    var req = function () { if (!raf) raf = requestAnimationFrame(upd); };
    d.addEventListener('scroll', req, { passive: true, capture: true });
    window.addEventListener('resize', req);
    upd();
  }

  function init(root) { initBA(root); initDots(root); initSticky(); }
  init(d);
  watchKaching();
  d.addEventListener('shopify:section:load', function (e) { init(e.target); syncAll(); });
})();
